module.exports = __webpack_public_path__ + "static/media/enhanced.b20a01d2.svg";